import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=0c0f4415&"
import script from "./Container.vue?vue&type=script&lang=js&"
export * from "./Container.vue?vue&type=script&lang=js&"
import style0 from "./Container.vue?vue&type=style&index=0&id=0c0f4415&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../kiwiirc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports